{
  "en": {
    "aiImage": {
      "confirm": {
        "deleteImage": {
          "text": "This action cannot be undone. The image will be permanently removed from your history.",
          "title": "Remove image?"
        },
        "moveAllToTrash": {
          "text": "All images will be removed from your history. You will find them in the trash afterwards.",
          "title": "Move images to trash?"
        }
      },
      "errors": {
        "generationFailed": "Image generation failed. Please try again.",
        "generationTimeout": "Image generation is taking unusually long and has been cancelled. Please try again.",
        "loadFailed": "The image could not be loaded. It may have been removed or you do not have access to it.",
        "rateLimitExceeded": "You have created too many images in a short time. Please wait a moment and try again."
      },
      "headers": {
        "form": "Create your own image",
        "proposals": "Proposals"
      },
      "hints": {
        "progressMessage": "Generating image..."
      },
      "imageStyles": {
        "concept_art": "Concept Art",
        "custom": "Default",
        "drawing": "Drawing",
        "graphics_3d": "3D Graphics",
        "origami": "Origami",
        "painting": "Painting",
        "photo": "Photo",
        "polaroid": "Polaroid"
      },
      "labels": {
        "copyPrompt": "Copy prompt",
        "create": "Create Image",
        "createdAt": "Created at",
        "imageSize": "Image size",
        "imageStyle": "Style",
        "model": "Model",
        "openImageInNewTab": "Open image in new tab",
        "prompt": "Prompt",
        "promptDescribe": "Describe your image",
        "provider": "Provider",
        "providerInfo": "More information",
        "result": "Result",
        "size": "Size"
      },
      "messages": {
        "allMovedToTrash": "All images have been moved to the trash",
        "deleted": "Image deleted"
      },
      "prompts": {
        "prompt1": "Bird's eye view of a ladybird sitting on a lush green blade of grass in a sunny meadow. The ladybird has bright red wings with black spots. Blurred flowers and a clear blue sky can be seen in the background. The scene is kept in a bright, lively style, focussing on the ladybird.",
        "prompt2": "A photorealistic portrait of a young engineering student with short black hair looking dreamily out of a large window in a modern university building. The shot is taken in soft, warm daylight and the camera is positioned at eye level. Blurred bookshelves and technical drawings can be seen in the background, giving the scene an academic and inspiring atmosphere.",
        "prompt3": "An impressionist painting of a middle-aged man walking along the bank of a raging river with a black umbrella in a storm. The scene is depicted in soft, flowing brushstrokes that capture the movement of the wind and rain. The sky is painted in dramatic shades of grey, while the river shimmers in deep blues and greens. The man wears a long, dark coat flapping in the wind and the colours of his coat and umbrella are slightly blurred to emphasise the intensity of the storm."
      },
      "tooltips": {
        "generatePrompt": "Enhance prompt",
        "generatePromptDisabled": "Enter a prompt first to enhance it"
      },
      "views": {
        "new": {
          "labels": {
            "imageStyle": "Choose your style"
          }
        }
      }
    }
  }
}
